import React from 'react';
import "./middle.css"

function Middle() {
  return (
   <>
  <div>
    <section className='home-community-board hsg-bg'>
  <div id="hs_cos_wrapper_module_158100233712830" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module"  data-hs-cos-general-type="widget" data-hs-cos-type="module">
  <section className="section-header" data-background>
   <div className='hsg-page-width-normal'>
    <h2 className='section-header__header-section-header--divider'>
      Learn and grow with award-winning support and a thriving community behind you.
    </h2>
    <p>You don't have to go it alone. Master the inbound methodology and get the most out of your tools with HubSpot's legendary customer support team and a community of thousands of marketing and sales pros just like you.</p>
   </div>
   </section>
   </div>
   
    
   
        
   <div id="hs_cos_wrapper_community" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module"  data-hs-cos-general-type="widget" data-hs-cos-type="module">
    <section className='hsg-page-width-normal2'>
   <div className='home-community-board__grid-wrapper'>
   
   
  <div className='home-community-board__grid-item'>
    <div className='home-community-board__grid-icon-wrapper' id="home-community-board__grid-icon-wrapper1">
    <img 
    data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_agency.svg" alt="" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_agency.svg"
    />

    </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>150 </p>
        <p className='home-community-board__grid-stat-description'>HubSpot user groups</p>
     
    </div>
  </div> 


   <div className='home-community-board__grid-item'>
    <div className='home-community-board__grid-icon-wrapper'  id="home-community-board__grid-icon-wrapper2">
    <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_blog.svg" alt="HubSpot Blogs" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_blog.svg"/>

    </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>7M </p>
        <p className='home-community-board__grid-stat-description'>monthly visits</p>
    </div>
  </div> 

   <div className='home-community-board__grid-item'>
    <div className='home-community-board__grid-icon-wrapper'  id="home-community-board__grid-icon-wrapper3">
    <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_academy.svg" alt="HubSpot Academy" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_academy.svg"/>
    </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>460K </p>
        <p className='home-community-board__grid-stat-description'>certified professionals</p>
    </div>
  </div> 

   <div className='home-community-board__grid-item' id="home-community-board__grid-item70k">
    <div className='home-community-board__grid-icon-wrapper'  id="home-community-board__grid-icon-wrapper4">
    <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_inbound.svg" alt="Inbound" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_inbound.svg"/> 
       </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>70K</p>
        <p className='home-community-board__grid-stat-description'>cregistered attendees</p>
    </div>
  </div> 


   <div className='home-community-board__grid-item' id="home-community-board__grid-item170k">
    <div className='home-community-board__grid-icon-wrapper'  id="home-community-board__grid-icon-wrapper5">
    <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_globe.svg" alt="" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="entered" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_globe.svg"/>      </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>170K</p>
        <p className='home-community-board__grid-stat-description'>certified professionals</p>
    </div>
  </div> 




  <div className='home-community-board__grid-item' id="home-community-board__grid-item170k">
    <div className='home-community-board__grid-icon-wrapper'  id="home-community-board__grid-icon-wrapper6">
    <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_followers.svg" alt="" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="entered" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_followers.svg"/>      </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>6</p>
        <p className='home-community-board__grid-stat-description'>langauge</p>
    </div>
  </div> 

  <div className='home-community-board__grid-item' id="home-community-board__grid-item170k">
    <div className='home-community-board__grid-icon-wrapper'  id="home-community-board__grid-icon-wrapper7">
    <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_blog.svg" alt="HubSpot Blogs" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_blog.svg"/>
     </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>3.5M</p>
        <p className='home-community-board__grid-stat-description'>social followers</p>
    </div>
  </div> 

  <div className='home-community-board__grid-item' id="home-community-board__grid-item45m">
    <div className='home-community-board__grid-icon-wrapper'  id="home-community-board__grid-icon-wrapper8">
    <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_agency.svg" alt="" className="home-community-board__grid-icon hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/parrotdad/homepage/homepage_community_agency.svg"/>
     </div>
    <div className='home-community-board__grid-stat-wrapper'>
        <p className='home-community-board__grid-stat stat-plus-after'>4.5M</p>
        <p className='home-community-board__grid-stat-description'>customers</p>
    </div>
  </div> 
    </div>
   
    </section>
    </div>
    </section> 

    <div id="hs_cos_wrapper_customers" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" data-hs-cos-general-type="widget" data-hs-cos-type="module">
<section className='home-customers'>
        <div className="hsg-page-width-normal3">
           <div className="home-customers__content-wrapper">
              <div className='home-customers__text-wrapper'>
                <h2 className='home-customers__stat'>143,000+</h2>
                <p className='home-customers__stat-description2'>
                customers in over 
                <strong>120</strong>
                countries growing their businesses with HubSpot
                </p>
              </div>
              <div className='home-customers__logos-grid'>
       <div className='home-customers__logo-wrapper'>
       <img data-src="https://f.hubspotusercontent00.net/hubfs/53/1200px-WWF_logo_svg%20(1).png" height="65" width="" alt="WWF logo" className="home-customers__logo hsg-deferred entered hsg-deferred-loaded" data-ll-status="entered" src="https://f.hubspotusercontent00.net/hubfs/53/1200px-WWF_logo_svg%20(1).png"/>
       </div>
       <div className='home-customers__logo-wrapper'>
       <img data-src="https://f.hubspotusercontent00.net/hubfs/53/trello-logo-blue%20(1).png" height="30" width="" alt="Trello logo" className="home-customers__logo hsg-deferred entered hsg-deferred-loaded" data-ll-status="entered" src="https://f.hubspotusercontent00.net/hubfs/53/trello-logo-blue%20(1).png"/>
       </div>
       <div className='home-customers__logo-wrapper'>
       <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/homepage/Vertical_Sabaeus_RGB.svg" height="45" alt="SurveyMonkey logo" className="home-customers__logo hsg-deferred entered hsg-deferred-loaded" data-ll-status="entered" src="https://www.hubspot.com/hubfs/assets/hubspot.com/homepage/Vertical_Sabaeus_RGB.svg"/>
       </div>
       <div className='home-customers__logo-wrapper'>
       <img data-src="https://newinboundblog.hubspot.com/hubfs/assets/hubspot.com/case-studies/logo-bank/EMEA-logo-bank/Suzuki.png"  height="22" alt="Suzuki logo" className="home-customers__logo hsg-deferred entered hsg-deferred-loaded" data-ll-status="entered" src="https://newinboundblog.hubspot.com/hubfs/assets/hubspot.com/case-studies/logo-bank/EMEA-logo-bank/Suzuki.png"/>
       </div>
       <div className='home-customers__logo-wrapper'>
       <img data-src="https://f.hubspotusercontent00.net/hubfs/53/soundcloud.png" alt="Soundcloud logo" height="22" className="home-customers__logo hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://f.hubspotusercontent00.net/hubfs/53/soundcloud.png"/>
       </div>
       <div className='home-customers__logo-wrapper'>
       <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/Classpass-logo@2x.png" height="40" alt="Classpass logo" className="home-customers__logo hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/Classpass-logo@2x.png"/>
       </div>
       <div className='home-customers__logo-wrapper'>
       <img data-src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/VMware_logo_gry_RGB_300dpi@2x.png" height="25" alt="VMware logo" className="home-customers__logo hsg-deferred entered hsg-deferred-loaded" data-ll-status="loaded" src="https://www.hubspot.com/hubfs/assets/hubspot.com/home/home_page_logos_June_2019/VMware_logo_gry_RGB_300dpi@2x.png"/>
       </div>
       
              </div>
           </div>
        </div>
</section>

</div>
 
</div>  
</>

  )
}

export default Middle
